/**
 * Global timezone patch — forces all Date display to Eastern Time (EST/EDT).
 *
 * Monkey-patches Date.prototype.toLocaleString / toLocaleDateString /
 * toLocaleTimeString so that when callers don't explicitly pass a `timeZone`
 * option, the output is rendered in America/New_York instead of the
 * container/browser local timezone (UTC in our Kubernetes pod).
 *
 * Notes:
 *   - Number.prototype.toLocaleString is NOT affected (different prototype),
 *     so currency / count formatting continues to work.
 *   - If calling code already specifies `timeZone`, we respect it.
 *   - This only changes DISPLAY — Date objects / timestamps themselves are
 *     unchanged (still UTC epoch under the hood).
 */

const APP_DEFAULT_TZ = 'America/New_York';

const withTz = (options) => {
  // options can be undefined, an object, or (rarely) a locale string passed
  // as second arg. We only care about the object form.
  if (options && typeof options === 'object' && !options.timeZone) {
    return { ...options, timeZone: APP_DEFAULT_TZ };
  }
  if (!options) {
    return { timeZone: APP_DEFAULT_TZ };
  }
  return options;
};

const origToLocaleString = Date.prototype.toLocaleString;
const origToLocaleDateString = Date.prototype.toLocaleDateString;
const origToLocaleTimeString = Date.prototype.toLocaleTimeString;

// eslint-disable-next-line no-extend-native
Date.prototype.toLocaleString = function patchedToLocaleString(locales, options) {
  return origToLocaleString.call(this, locales || 'en-US', withTz(options));
};

// eslint-disable-next-line no-extend-native
Date.prototype.toLocaleDateString = function patchedToLocaleDateString(locales, options) {
  return origToLocaleDateString.call(this, locales || 'en-US', withTz(options));
};

// eslint-disable-next-line no-extend-native
Date.prototype.toLocaleTimeString = function patchedToLocaleTimeString(locales, options) {
  return origToLocaleTimeString.call(this, locales || 'en-US', withTz(options));
};

export const APP_TIMEZONE = APP_DEFAULT_TZ;
